import { combineReducers } from '@reduxjs/toolkit';

// ------- IMPORT REDUCERS -------
import appReducer from 'app/pages/Dashboard/slice/dashboardSlice';
import loginReducer from 'app/pages/Login/slice/loginSlice';
// ------- HOURS OF SERVICE -------
import driverLogsReducer from 'app/pages/hos/DriverLogs/slice/driverLogsSlice';
import driverStatusReducer from 'app/pages/hos/DriverStatus/slice/driverStatusSlice';
import drivingViolationsReducer from 'app/pages/hos/DrivingViolations/slice/drivingViolationsSlice';
import eldMalfunctionsReducer from 'app/pages/hos/EldMalfunctions/slice/eldMalfunctionsSlice';
import locationsReducer from 'app/pages/hos/Locations/slice/locationsSlice';
import logEditsReducer from 'app/pages/hos/LogEdits/slice/logEditSlice';
import hosReportsReducer from 'app/pages/hos/Reports/slice/reportsSlice';
import unidentifiedDrivingReducer from 'app/pages/hos/UnidentifiedDriving/slice/unidentifiedDrivingSlice';
import dataTransferReducer from 'app/pages/hos/DataTransfer/slice/dataTransferSlice';
// ------- IFTA (STATE MILEAGE) -------
import fuelReceiptsReducer from 'app/pages/state-mileage/FuelReceipts/slice/fuelReceiptSlice';
import iftaReportsReducer from 'app/pages/state-mileage/Reports/slice/iftaReportSlice';
// ------- DVIR -------
import dvirHistoryReducer from 'app/pages/dvir/DvirHistory/slice/dvirHistorySlice';
import dvirReportsReducer from 'app/pages/dvir/Reports/slice/dvirReportSlice';
// ------- MOBILE WORKER -------
import mobileWorkerReportsReducer from 'app/pages/mobile-worker/Reports/slice/mobileWorkerReportsSlice';
import workOrdersReducer from 'app/pages/mobile-worker/WorkOrders/slice/workOrderSlice';
import jobSitesReducer from 'app/pages/mobile-worker/JobSites/slice/jobSitesSlice';
// ------- SETTINGS -------
import alertsReducer from 'app/pages/settings/Alerts/slice/alertsSlice';
import accountsReducer from 'app/pages/settings/Accounts/slice/accountSlice';
import accountSettingsReducer from 'app/pages/settings/AccountSettings/slice/accountSettingSlice';
import carrierInfoReducer from 'app/pages/settings/CarrierInformation/slice/carrierInfoSlice';
import driverExceptionsReducer from 'app/pages/settings/DriverExceptions/slice/driverExceptionsSlice';
import driversReducer from 'app/pages/settings/Drivers/slice/driverSlice';
import dvirFormReducer from 'app/pages/settings/DvirForm/slice/dvirFormSlice';
import terminalReducer from 'app/pages/settings/Terminals/slice/terminalSlice';
import userReducer from 'app/pages/settings/Users/slice/userSlice';
import equipmentReducer from 'app/pages/settings/Equipments/slice/equipmentSlice';
import pushNotificationReducer from 'app/pages/settings/Push-Notification/slice/pushNotificationSlice';
import formSetupReducer from 'app/pages/settings/FormSetup/slice/formSetupSlice';
import SupportContact from 'app/pages/settings/SupportContact/slice/supportContactSlice';
import resourceReducer from 'app/pages/settings/Resources/slice/resourceSlice';
import buttonEditorReducer from 'app/pages/settings/ButtonEditor/slice/buttonEditorSlice';
import uploadResourceReducer from 'app/pages/settings/UploadResources/slice/uploadResourceSlice';
// ------- Admin Tools -------
import emailNotificationReducer from 'app/pages/adminTools/EmailNotification/slice/emailNotificationSlice';
import stateMileageTaxRateReducer from 'app/pages/adminTools/StateMileageTaxRates/slice/stateMileageTaxRateSlice';
import dataTransferAdminReducer from 'app/pages/adminTools/DataTransferAdmin/slice/dataTransferAdminSlice';
/**
 * Returns all the combined reducers.
 */
export function getAllReducers() {
  return combineReducers({
    app: appReducer,
    login: loginReducer,
    // HOURS OF SERVICE
    driverStatus: driverStatusReducer,
    driverLogs: driverLogsReducer,
    locations: locationsReducer,
    unidentifiedDriving: unidentifiedDrivingReducer,
    hosReports: hosReportsReducer,
    violations: drivingViolationsReducer,
    eldMalfunctions: eldMalfunctionsReducer,
    logEdits: logEditsReducer,
    dataTransfer: dataTransferReducer,
    // IFTA
    fuelReceipts: fuelReceiptsReducer,
    iftaReports: iftaReportsReducer,
    // DVIR
    dvirHistory: dvirHistoryReducer,
    dvirReports: dvirReportsReducer,
    // MOBILE WORKER
    mobileWorkerReports: mobileWorkerReportsReducer,
    workOrders: workOrdersReducer,
    jobSites: jobSitesReducer,
    // SETTINGS
    alerts: alertsReducer,
    accounts: accountsReducer,
    carrierInfo: carrierInfoReducer,
    driverExceptions: driverExceptionsReducer,
    drivers: driversReducer,
    dvirForm: dvirFormReducer,
    terminal: terminalReducer,
    user: userReducer,
    equipment: equipmentReducer,
    pushNotification: pushNotificationReducer,
    accountSettings: accountSettingsReducer,
    formSetup: formSetupReducer,
    supportContact: SupportContact,
    resource: resourceReducer,
    buttonEditor: buttonEditorReducer,
    uploadResource: uploadResourceReducer,
    // ADMIN TOOLS
    emailNotifications: emailNotificationReducer,
    stateMileageTaxRates: stateMileageTaxRateReducer,
    dataTransferAdmin: dataTransferAdminReducer,
  });
}
